import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { DividerStyleDefaultsModel } from './divider-style-defaults.model';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';
import { StyleStateEnum } from '../enums/style-state.enum';

export class DividerStyleFieldModel implements FormFieldModel {
    property: string;
    isPrimary: boolean;
    defaults: DividerStyleDefaultsModel;
    label?: string;
    showStyleState?: boolean;
    styleType?: StyleTypesApiEnum;
    fieldComponent?: Type<AbstractFormFieldComponent>;
    description?: string;
    defaultStyleStateOptions: DropdownOptionModel[] = [
        { label: 'PageBuilder.formField.styles.defaultAgilityStyle', value: StyleStateEnum.DEFAULT },
        { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
    ];
    changeDefaultStyleStateOptions: (x: any) => DropdownOptionModel[];
    allowExpertMode?: boolean = true;

    constructor(
        property: string,
        isPrimary: boolean = true,
        defaults: DividerStyleDefaultsModel,
        label?: string,
        showStyleState?: boolean,
        styleType?: StyleTypesApiEnum,
        fieldComponent?: Type<AbstractFormFieldComponent>,
        description?: string,
        defaultStyleStateOptions?: DropdownOptionModel[],
        changeDefaultStyleStateOptions?: (x: any) => DropdownOptionModel[]
    ) {
        this.property = property;
        this.isPrimary = isPrimary;
        this.defaults = defaults;
        this.label = label;
        this.showStyleState = showStyleState;
        this.styleType = styleType;
        this.fieldComponent = fieldComponent;
        this.description = description;
        this.defaultStyleStateOptions = defaultStyleStateOptions;
        this.changeDefaultStyleStateOptions = changeDefaultStyleStateOptions;
    }
}
